import { render } from "./TemplateListHeader.vue?vue&type=template&id=18cb6514&scoped=true"
import script from "./TemplateListHeader.vue?vue&type=script&lang=js"
export * from "./TemplateListHeader.vue?vue&type=script&lang=js"

import "./TemplateListHeader.vue?vue&type=style&index=0&id=18cb6514&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18cb6514"]])

export default __exports__